import moment from "moment";
import {
  FORMAT_TYPE_Year_Month_Day,
  FORMAT_TYPE_Year,
} from "@/config/variables.js";

const FormatDatePlugin = {
  install(app) {
    app.config.globalProperties.formatTo_YearMonthDate = (val) => {
      return moment(val).format(FORMAT_TYPE_Year_Month_Day);
    };
    app.config.globalProperties.formatTo_Year = (val) => {
      return moment(val).format(FORMAT_TYPE_Year);
    };

    app.config.globalProperties.formatStartYearMonthDate = (val, typeProp) => {
      const type = typeProp ? typeProp : "day";
      return moment(val).startOf(type).format(FORMAT_TYPE_Year_Month_Day);
    };
    app.config.globalProperties.formatEndYearMonthDate = (val, typeProp) => {
      const type = typeProp ? typeProp : "day";
      return moment(val).endOf(type).format(FORMAT_TYPE_Year_Month_Day);
    };
  },
};

export default FormatDatePlugin;
